"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Object used for windows calls to make window object testable
 */
var WindowLocation = /** @class */ (function () {
    function WindowLocation() {
    }
    WindowLocation.prototype.assign = function (url) {
        window.location.assign(url);
    };
    Object.defineProperty(WindowLocation.prototype, "pathname", {
        get: function () {
            return window.location.pathname;
        },
        set: function (value) {
            window.location.pathname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocation.prototype, "origin", {
        get: function () {
            return window.location.origin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocation.prototype, "hostname", {
        get: function () {
            return window.location.hostname;
        },
        set: function (value) {
            window.location.hostname = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocation.prototype, "port", {
        get: function () {
            return window.location.port;
        },
        set: function (value) {
            window.location.port = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocation.prototype, "protocol", {
        get: function () {
            return window.location.protocol;
        },
        set: function (value) {
            window.location.protocol = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocation.prototype, "hash", {
        get: function () {
            return window.location.hash;
        },
        set: function (value) {
            window.location.hash = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocation.prototype, "href", {
        get: function () {
            return window.location.href;
        },
        set: function (value) {
            window.location.href = value;
        },
        enumerable: true,
        configurable: true
    });
    return WindowLocation;
}());
exports.WindowLocation = WindowLocation;
